import styled from '@emotion/styled'

export const PeriodsFiltersContainerStyle = styled.div<{
  disabled?: boolean
  width?: number
}>`
  font-family: 'Fira Sans', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  display: flex;
  align-items: center;
  letter-spacing: 0.02em;
  color: ${({ disabled }) => (disabled ? '#929292' : '#252525')};
  width: ${({ width }) => (width ? `${width}px` : '200px')};
  height: 32px;
  border-radius: 4px;
  border-bottom: 1px solid #e3e3e3;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
`

export const PeriodsFiltersLabelStyle = styled.div<{
  disabled?: boolean
}>`
  font-family: 'Fira Sans', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.02em;
  color: ${({ disabled }) => (disabled ? '#929292' : '#252525')};
  padding: 8px;
`
export const PeriodsFiltersMenuStyle = styled.div`
  z-index: 45;
  position: absolute;
  top: 36px;
  left: 0px;
  height: ${({ open }: { open: boolean }) => (open ? '196px' : '0')};
  max-height: ${({ open }: { open: boolean }) => (open ? '334px' : '0')};
  visibility: ${({ open }: { open: boolean }) => (open ? 'visible' : 'hidden')};
  opacity: ${({ open }: { open: boolean }) => (open ? '1' : '0')};
  background: white;
  width: 200px;
  border-radius: 4px;
  // -webkit-transition: max-height 300ms ease-in-out, opacity 300ms ease-in-out;
  // -moz-transition: max-height 300ms ease-in-out, opacity 300ms ease-in-out;
  // -o-transition: max-height 300ms ease-in-out, opacity 300ms ease-in-out;
  // transition: max-height 300ms ease-in-out, opacity 300ms ease-in-out;
  padding-bottom: 8px;
`
